import React from 'react';
import Tippy from '@tippyjs/react';
import { CellSpan, TooltipBoxTableContainer, TootipTable } from './styles';

export const CustomCell: React.FC<{
  value: string;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <div>
    <Tippy placement="bottom" content={children} maxWidth={500}>
      <CellSpan title={value}>{value}</CellSpan>
    </Tippy>
  </div>
);

type TooltipBoxTableColumnsHeader = string[];
type TooltipBoxTableRows = string[][];

export const TooltipBoxTable: React.FC<{
  title: string;
  columns: TooltipBoxTableColumnsHeader;
  rows: TooltipBoxTableRows;
}> = ({ title, columns, rows }) => (
  <TooltipBoxTableContainer>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div>
        <span style={{ font: '16px', fontWeight: 'bold' }}>{title}</span>
      </div>
      <div>
        <TootipTable>
          <tbody>
            <tr>
              {columns.map((column: string) => (
                <th key={column}>{column}</th>
              ))}
            </tr>
            {rows.map((row, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={index}>
                {row.map(value => (
                  <td>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </TootipTable>
      </div>
    </div>
  </TooltipBoxTableContainer>
);
